import paymentClient from '../services/http-client';
import { useModuleMutation } from '../../useModuleMutation';
import { paymentModuleKeys } from './queries';
import type { 
  CreatePaymentLinkRequest, 
  CreatePaymentLinkResponse, 
  DeletePaymentResponse,
  RefundRequest, 
  RefundResponse 
} from './interfaces';

// POST /payment/create-payment-link
// Success and error messages are handled in the component using this mutation.
export const useCreatePaymentLinkMutation = () =>
  useModuleMutation({
    fn: (data: CreatePaymentLinkRequest) =>
      paymentClient.post<CreatePaymentLinkResponse>('payment/create-payment-link', data),
    invalidate: (clientId) => [paymentModuleKeys.payments(clientId)],
  });

// POST payment?_api=/payment/{token}/refund - Refund (partial or full)
// Note: Only available for payments with status 'completed'
export const useRefundPaymentMutation = () =>
  useModuleMutation({
    fn: ({ token, data }: { token: string; data: RefundRequest }) =>
      paymentClient.post<RefundResponse>('payment', data, { params: { _api: `/payment/${token}/refund` } }),
    invalidate: (clientId, _data, { token }) => [
      paymentModuleKeys.payments(clientId),
      paymentModuleKeys.paymentByToken(clientId, token),
    ],
  });

// DELETE payment?_api=/payment/{token} - Delete an expired/unpaid payment link
// Note: Only available when policy.canBeDeleted is true
export const useDeletePaymentMutation = () =>
  useModuleMutation({
    fn: (token: string) =>
      paymentClient.delete<DeletePaymentResponse>('payment', { params: { _api: `/payment/${token}` } }),
    invalidate: (clientId, _data, token) => [
      paymentModuleKeys.payments(clientId),
      paymentModuleKeys.paymentByToken(clientId, token),
    ],
  });
